import Observer from 'common/scripts/observer';
import Panzoom from '@panzoom/panzoom';
import {Utils} from 'common/scripts/utils';

const observer = new Observer();

if (Utils.isMobile()) {
    observer.subscribe('popup:open', (popup) => {
        if (!popup.popup) {
            return;
        }

        const zoomistElement = popup.popup.querySelector('.j-zoom-image');

        if (!zoomistElement) {
            return;
        }

        const panzoom = Panzoom(zoomistElement, {
            minScale: 1,
            maxScale: 30,
            overflow: 'visible'
        });
        const parent = zoomistElement.parentElement;

        if (parent) {
            parent.addEventListener('wheel', panzoom.zoomWithWheel);
        }
    });
}
